import React from 'react';

function AccLinkVendorPage() {
    return <div>AccLinkVendorPage</div>;
}

export default AccLinkVendorPage;
